"use strict";

/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */
exports.build = "minimal";

// Serialization
exports.Writer       = require(44);
exports.BufferWriter = require(45);
exports.Reader       = require(18);
exports.BufferReader = require(19);

// Utility
exports.util         = require(37);
exports.rpc          = require(22);
exports.roots        = require(21);
exports.configure    = configure;

/* istanbul ignore next */
/**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */
function configure() {
    exports.util._configure();
    exports.Writer._configure(exports.BufferWriter);
    exports.Reader._configure(exports.BufferReader);
}

// Set up buffer utility according to the environment
configure();
